export enum PaymentMethodFormField {
  PaymentType = 'paymentType',
}
